
import { Component, Prop, Vue } from 'vue-property-decorator'

import { getCardPricing } from '@/api/cardPricing'
import { DotationOrderForm } from '../types/dotationOrderForm'

@Component({ name: 'StepCardOptions' })
export default class extends Vue {
  @Prop({ required: true }) form!: DotationOrderForm

  issuancePrice: number | null = null
  loadingRate: number | null = null

  async created(): Promise<void> {
    try {
      const pricing = await getCardPricing()
      this.issuancePrice = pricing.issuancePrice
      this.loadingRate = pricing.loadingRate
    } catch {
      // Keep the hint's price/rate blank rather than showing a possibly wrong figure.
    }
  }

  get bankCardHint(): string {
    if (this.issuancePrice === null || this.loadingRate === null) {
      return this.$t('newDotationOrder.cardOptions.bankCardHintLoading') as string
    }

    return this.$t('newDotationOrder.cardOptions.bankCardHint', {
      issuancePrice: this.$n(this.issuancePrice, 'currency'),
      loadingRate: this.$n(this.loadingRate, 'percent')
    }) as string
  }

  onBankCardToggle(enabled: boolean | string | number): void {
    if (!enabled) {
      this.form.cardFunding = ''
      this.form.organizationIssuanceSubsidyPercent = 100
      this.form.organizationLoadingSubsidyPercent = 100
    }
  }
}
